var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError500(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c6c4c5",
    d: "M24.1 160.1l-3.2-1.4 19.9-46.2 3.2 1.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 109.6c-.9-.7-34.3-51.5-34.3-51.5L1.3.4s7.4 11.3 22 17.6C37.9 24.2 52 22.1 52 22.1L37.9 67.4l6.3 42.2z",
    fill: "#ff549e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1 109.6c1.2.2 62.7-10 62.7-10l46.3-34.3s-13.3 2.4-27.9-3.8c-14.6-6.2-22.8-17.8-22.8-17.9l-29 38-29.3 28z",
    fill: "#d10d62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 109.4l-6.1-42.3 14-45.2S60 33 76.7 40.2c16.7 7.2 20.7 4.4 25.8 3.4 0 0-21.7 42.5-22.9 42s-35.4 23.8-35.4 23.8",
    fill: "#f01f7a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 188.9c-12.2-4.7-7.1-16.4-4.8-21.8l3.7-8.7 6.4 2.7-3.7 8.7c-3.5 8.1-3.3 11.5 1.1 13.5 2.3 1 4.2.7 5.5-.2 1-.7 1.7-2.4 2.3-3.8l.1-.2s1.3-1.1 3.8-.1c2.4.9 2.6 2.9 2.6 2.9l-.1.2c-.9 2.1-2.1 5-4.7 6.8-3 2-5.3 2.7-12.2 0",
    fill: "#394754"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7 22.8S37.1 65.7 38 67.3c.8 1.3 2.7 50.2 2.7 50.2L13.2 62.1c-2-1.8-12.1-61-12.1-61",
    fill: "none",
    stroke: "#c6c4c5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.4 44.1L79.5 85.8l-37.7 31c2.6-1.7 60.1-16.7 60.6-17.9l50-33",
    fill: "none",
    stroke: "#adaaac",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError500);
export default __webpack_public_path__ + "static/media/error-500.4dbaaf9af8c8f1141f9600df6aed4016.svg";
export { ForwardRef as ReactComponent };